import { Link, useParams } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";

export default function NotFound() {
  const { type } = useParams();

  return (
    <SiteLayout>
      <div className="w-full px-4 md:px-6 py-16 md:py-24">
        <div className="rounded-lg border hairline bg-background-900/60 px-6 py-14 text-center relative overflow-hidden">
          <p className="font-heading text-[80px] md:text-[120px] leading-none font-bold text-background-700 select-none">
            404
          </p>
          <h1 className="mt-2 font-heading text-xl md:text-2xl font-semibold text-foreground-50">
            没有找到这个页面
          </h1>
          <p className="mt-3 text-sm text-foreground-400">
            路径 {type ? `/category/${type}` : ""} 可能已被移动或不存在，也可能链接输入有误。
          </p>
          <div className="mt-6 flex flex-wrap items-center justify-center gap-2.5">
            <Link
              to="/"
              className="h-10 px-5 rounded-md bg-accent-500 text-background-950 text-sm font-medium flex items-center gap-1.5 hover:bg-accent-400 transition-colors whitespace-nowrap"
            >
              返回首页
            </Link>
            <Link
              to="/category/hot-blood"
              className="h-10 px-5 rounded-md border hairline text-sm text-foreground-200 flex items-center gap-1.5 hover:border-accent-500/50 hover:text-accent-300 transition-colors whitespace-nowrap"
            >
              浏览分类
            </Link>
            <Link
              to="/search"
              className="h-10 px-5 rounded-md border hairline text-sm text-foreground-200 flex items-center gap-1.5 hover:border-accent-500/50 hover:text-accent-300 transition-colors whitespace-nowrap"
            >
              搜索漫画
            </Link>
          </div>
        </div>
      </div>
    </SiteLayout>
  );
}